import { getInfrastructureArchitecturePossibleServicesEndpointSelector } from "./getInfrastructureArchitecturePossibleServicesEndpointSelector";
import { RootState } from "@/store/store";
import { getInfrastructureArchitecturePossibleRegionsEndpointSelector } from "@/store/infrastructure-architecture/getInfrastructureArchitecturePossibleRegionsEndpointSelector";

export const infrastructureArchitecturePossibleServicesRegionsLoadingSelector =
  (state: RootState): boolean | undefined => {
    const servicesLoading =
      getInfrastructureArchitecturePossibleServicesEndpointSelector(
        state,
      )?.isLoading;
    const regionsLoading =
      getInfrastructureArchitecturePossibleRegionsEndpointSelector(
        state,
      )?.isLoading;

    return servicesLoading || regionsLoading;
  };
